import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isNull } from 'lodash-es'
import { TtIcon } from '@23/react'

import { intl } from 'lang/intl'
import {
  getTimerBroadcastingProps,
  isBroadcastLive,
  isBroadcastRecording,
  getCurrentViewers,
} from '../../../selectors'

import { QualityIndicatorComponent } from '../../../../RoomUI/components/QualityIndicatorComponent/QualityIndicatorComponent'
import { LiveTimersComponent } from '../../../shared/components'
import { useLocalParticipant } from '../../../../webrtc/webRTCRoom'
import { useConnectInfoQuery } from '../../../../global/blocs/useConnectInfo'

const Counters = ({
  /**
   * Connected properties
   */
  timerBroadcastingProps,
  isBroadcasting,
  isRecording,
  currentViewers,
}) => {
  const participant = useLocalParticipant()
  const { data: connectInfo } = useConnectInfoQuery()

  if (!isBroadcasting || !isRecording) {
    return null
  }

  return (
    <>
      {!isNull(currentViewers) && (
        <div className="current-viewers">
          <TtIcon className="icon" name="account-multiple" library="23" />
          {currentViewers}
        </div>
      )}
      <div className="timer-indicator broadcasting">
        {connectInfo.streaming_method !== 'hardware' && (
          <QualityIndicatorComponent
            reason={intl.formatMessage({
              defaultMessage:
                'A speaker is currently experiencing issues with their connection',
            })}
            participantId={participant?.id}
            enableGlow={false}
          />
        )}
        <LiveTimersComponent
          liveInfo={timerBroadcastingProps}
          showRecording={false}
          showStreaming={false}
          noButtonStyles
        />
      </div>
    </>
  )
}

Counters.propTypes = {
  /**
   * Connected properties
   */
  timerBroadcastingProps: PropTypes.shape({
    broadcasting_p: PropTypes.oneOf([1, 0]),
    broadcasting_start_time: PropTypes.string,
  }),
  isBroadcasting: PropTypes.bool,
  isRecording: PropTypes.bool,
  currentViewers: PropTypes.number,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  timerBroadcastingProps: getTimerBroadcastingProps(state),
  isBroadcasting: isBroadcastLive(state),
  isRecording: isBroadcastRecording(state),
  currentViewers: getCurrentViewers(state),
})

export default connect(mapStateToProps)(Counters)
